export enum FeedbacksGetters {
    GET_ALL_FEEDBACKS = 'GET_ALL_FEEDBACKS',
    GET_FEEDBACK_AVERAGE = 'GET_FEEDBACK_AVERAGE',
    GET_FEEDBACK_CARDS = 'GET_FEEDBACK_CARDS',
    GET_MONTH_SUGGESTIONS = 'GET_MONTH_SUGGESTIONS',
    GET_ALL_COMMENTS = 'GET_ALL_COMMENTS',
    GET_SUGGESTIONS = 'GET_SUGGESTIONS',
}
